import Landingpage from './Pages/landingPage/index'

function App() {
  return (
    <div className="App">
     <div>
       <Landingpage />
     </div>
    </div>
  );
}

export default App;
